import { render } from "./AllRound.vue?vue&type=template&id=23b1fc02"
import script from "./AllRound.vue?vue&type=script&lang=js"
export * from "./AllRound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__